<template>
  <div id="vacations-scheduler">
    <Breadcrumbs :breadcrumbs="[
      {title: this.$t('menu.configurations'), disabled: true},
      {title: this.$t('menu.vacation_scheduler'), disabled: true}
    ]">

    </Breadcrumbs>

    <div v-if="isLoading">
      <LoadingPlaceholder />
    </div>
    <div v-else>
      <div class="row">
        <div class="col-12 col-md-6">
          <label class="form-label">
            {{ $t('menu.users') }}
          </label>
          <multiselect
            id="entities-filter"
            v-model="filters.users"
            :options="usersOptions"
            track-by="id"
            label="name"
            :placeholder="$t('menu.users')"
            :allow-empty="true"
            :multiple="true"
            :internal-search="true"
            @input="$forceUpdate()"
          >

            <template slot="clear">

              <span class="multiselect__clear" v-if="filters.users.length !== 0"
                    @mousedown.prevent.stop="filters.users = []"></span>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="row justify-content-center">
        <div>
          <va-button class="round ml-4"
                     style="background-color: #6cb412"
                     @click="handleChangeDate('previous')"
                     :disabled="moment(selectedYear, 'YYYY').startOf('year').isSame(moment().add(-2, 'year').startOf('year'), 'year')">
            <i class="fa fa-chevron-left">
            </i>
          </va-button>
          <span class="is-bold" style="font-size: 26px">
            {{selectedYear}}
          </span>
          <va-button class="round"
                     style="background-color: #6cb412"
                     @click="handleChangeDate('next')"
                     :disabled="moment(selectedYear, 'YYYY').startOf('year').isSame(moment().add(1, 'year').startOf('year'), 'year')">
            <i class="fa fa-chevron-right">
            </i>
          </va-button>
          <span class="is-bold" v-if="hasMadeChanges" style="color: #bb260d; font-size: 18px"><i class="fa fa-exclamation-circle"></i> Por Sincronizar</span>
          <va-popover
            v-if="hasMadeChanges"
            placement="top"
            :message="$t('agenda.availability.save')">
            <va-button large icon="fa fa-upload" @click.prevent="handleSubmitData"></va-button>
          </va-popover>
          <span class="is-bold" v-else style="color: #6cb412; font-size: 18px"><i class="fa fa-check-circle"></i> Sincronizado</span>
        </div>
      </div>
      <div class="year-calendar-wrapper mt-2">
        <table v-for="elem in calendarData">
          <tr>
            <th colspan="7" class="text-center is-bold table-month-header"> {{ elem.month }} </th>
          </tr>
          <tr>
            <th class="table-weekdays-header" v-for="day in weekDays"> {{day.text}} </th>
          </tr>
          <tr v-for="week in elem.daysWithinWeeks">
            <td v-for="(dayObj, idx) in week" :key="idx"
                :class="{'is-local-holiday': dayObj && dayObj.localHoliday && dayObj.localHoliday !== null, 'is-weekend' : dayObj && dayObj.type === 'weekend', 'is-holiday' : dayObj && dayObj.type === 'holiday', clickable: dayObj && dayObj.type !== 'weekend' && dayObj.type !== 'holiday'}"
                @click="handleDayClick({month: elem.month, day: dayObj})"
            >
              <div v-if="dayObj && dayObj.type === 'holiday'">
                <va-popover
                  placement="top"
                  :message="dayObj.data.name">
                <span >
                  {{dayObj ? dayObj.day : ''}}
                </span>
                </va-popover>
              </div>

              <div v-else-if="dayObj && dayObj.vacations && dayObj.vacations.length > 0">
                <va-popover
                  style="display: grid"
                  placement="top"
                  class="w-100"
                  >
                  <template slot="popover">
                    <div>
                      <span v-if="dayObj.localHoliday">{{dayObj.localHoliday.data.name}}</span>
                      <ul>
                        <li v-for="vacation in dayObj.vacations" :style="{color: vacation.color}"> • {{vacation.userName}}</li>
                      </ul>
                    </div>


                  </template>
                  <span >
                    {{dayObj ? dayObj.day : ''}}
                  </span>
                  <div v-for="vacation in dayObj.vacations"
                       :style="{'background-color': vacation['color'], height: '5px'}"
                       :class="{ 'striped-background': !vacation.approved }"
                  >
                  </div>
                </va-popover>

              </div>
              <span v-else>
                <va-popover
                  style="display: grid"
                  placement="top"
                  class="w-100"
                  v-if="dayObj && dayObj.localHoliday"
                >
                  <template slot="popover">
                    <div>
                      <span>{{dayObj.localHoliday.data.name}}</span>
                    </div>
                  </template>
                  <span >
                    {{dayObj ? dayObj.day : ''}}
                  </span>
                </va-popover>
                <span v-else>
                  {{dayObj ? dayObj.day : ''}}
                </span>
              </span>
            </td>
          </tr>
        </table>
      </div>
      <!--<div class="row">
        <div class="col-6">
          <h3 class="mt-4">
            {{capitalizeFirst(displayedDate.format('MMMM'))}}
            {{displayedDate.year()}}
          </h3>
        </div>
        <div class="col-6 text-right">
          <span v-if="hasMadeChanges" style="color: #bb260d"><i class="fa fa-check-circle"></i> Por Sincronizar</span>
          <span v-else style="color: #6cb412"><i class="fa fa-check-circle"></i> Sincronizado</span>

          <va-button class="round ml-4"
                     @click="handleChangeDate('previous')"
                     :disabled="displayedDate.isSame(moment().startOf('year'), 'month')">
            <i class="fa fa-chevron-left">
            </i>
          </va-button>
          <va-button class="round center-rounded"
                     @click="handleChangeDate('current')"
                     :disabled="displayedDate.isSame(moment(), 'month')">
            <span style="color: white">Mês Atual</span>
          </va-button>
          <va-button class="round"
                     @click="handleChangeDate('next')"
                     :disabled="displayedDate.isSame(moment().endOf('year'), 'month')">
            <i class="fa fa-chevron-right">
            </i>
          </va-button>
        </div>
      </div>

      <div class="timeline-wrapper mt-4" >
        <div class="timeline">
          <div class="colaborator-column" >
            <span></span>
          </div>
          <div class="day-column" v-for="date in daysDate" :key="date.id"
               :class="{ 'is-weekend': date.momentDate.day()%6===0,
             'is-holiday': holidays.some(elem => elem.date.isSame(date.momentDate, 'day')) }">
            <span>{{ date.momentDate.format('DD') }}</span>
            <br/>
            <span style="font-size: 12px">{{ date.momentDate.locale('pt').format('ddd') }}</span>
          </div>
        </div>
        <div class="timeline" v-for="elem in data">
          <div class="colaborator-column">
            <span>{{ elem.name }}</span>
          </div>
          <div class="day-column" v-for="day in elem.vacations" :key="day.idx"
               :class="{ 'is-weekend': day.momentDate.day()%6===0,
             'is-holiday': holidays.some(elem => elem.date.isSame(day.momentDate, 'day')),
             }"
               @click.prevent="handleDayClick({resource: {name: elem.name, id: elem.id}, date: day.momentDate, vacation: day.vacation})">
            <div class="is-vacation-approved" v-if="day.vacation && day.vacation.type === 'vacation' && day.vacation.approval_status === 'approved'">
            </div>
            <div class="is-vacation-unapproval" v-if="day.vacation && day.vacation.type === 'vacation' && day.vacation.approval_status === 'unapproved'">
            </div>
            <div class="is-vacation-to-be-approved" v-if="day.vacation && day.vacation.type === 'vacation' && day.vacation.approval_status === 'pending'">
            </div>
            <div class="is-vacation-approved-unsubmited" v-if="day.vacation && day.vacation.type === 'vacation' && day.vacation.approval_status === 'approved_unsubmited'">
            </div>
          </div>
        </div>
        <div class="row" style="min-height: 10px"></div>
      </div>-->
      <!--<div class="mt-3 pl-3">
        <div class="row">
          <div class="is-vacation-approved" style="height: 15px !important; width: 10px !important; padding:8px"></div>
          <div class="pl-2"><span style="font-size: 14px"> Aprovado </span></div>
        </div>
        <div class="row" v-if="hasApprovalPermission">
          <div class="is-vacation-unapproval" style="height: 15px !important; width: 10px !important; padding: 8px"></div>
          <div class="pl-2"><span style="font-size: 14px"> Reprovado </span></div>
        </div>
        <div class="row">
          <div class="is-vacation-to-be-approved" style="height: 15px !important; width: 10px !important; padding: 8px"></div>
          <div class="pl-2"><span style="font-size: 14px"> Pendente Aprovação </span></div>
        </div>
      </div>-->

      <div class="mt-4 row">
        <div class="col-8">
          <h5 class="is-bold">Dias Marcados e Remanescentes</h5>
          <table class="mt-3" id="days-left-table">
            <thead>
            <tr>
              <th>
                <span class="is-bold">
                  Funcionário
                </span>
              </th>
              <th>
                <span class="is-bold">
                  Remanescente {{moment().subtract(1, 'year').year()}}
                </span>
              </th>
              <th>
                <span class="is-bold">
                  Remanescente Total
                </span>
              </th>
              <th>
                <span class="is-bold">
                  Dias Marcados
                </span>
              </th>
              <th>
                <span class="is-bold">
                  Dia Aniversário
                </span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(user, index) in data">
              <td class="table-column">
                <div class="d-flex">
                  <div style="width: 8px; height: 36px; margin-top: -5px; margin-bottom: -6px; margin-left: -4px" :style="{'background-color': userColors[index]}"/>
                  <span class="is-bold ml-2"> {{user.name}} </span>
                </div>
              </td>
              <td class="table-column">
                {{user.last_year_days_unscheduled}}
              </td>
              <td class="table-column">
                {{user.total_unscheduled}}
              </td>
              <td class="table-column">
                {{user.total_given - user.total_unscheduled}}
              </td>
              <td class="table-column">
                {{user.birthday_day_scheduled ? 0 : 1}}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="mt-4 row">
        <div class="col-4" v-if="holidays.length">
          <h5 class="is-bold">Feriados Nacionais</h5>
          <table class="mt-3">
            <thead>
            <tr>
              <th class="table-column">
                <span class="is-bold">
                  Data
                </span>
              </th>
              <th class="table-column">
                <span class="is-bold">
                  Feriado
                </span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="holiday in holidays">
              <td class="table-column">
                {{holiday.date.format('DD MMMM')}}
              </td>
              <td class="table-column">
                {{holiday.name}}
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="col-4" v-if="holidays.length">
          <h5 class="is-bold">Feriados Locais</h5>
          <table class="mt-3">
            <thead class="local-holiday-thead-bg">
            <tr>
              <th class="table-column">
                <span class="is-bold">
                  Data
                </span>
              </th>
              <th class="table-column">
                <span class="is-bold">
                  Feriado
                </span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="holiday in localHolidays">
              <td class="table-column">
                {{holiday.date.format('DD MMMM')}}
              </td>
              <td class="table-column">
                {{holiday.name}}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>


      <!--<div>
        <Calendar
          language="pt"
          :disabled-week-days="[0,6]"
          :weekStart="1"
          :dataSource="dataSource"
        />
      </div>-->
    </div>



  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs.vue";
import moment from "moment";
import { AttendandeAndVacationsService } from "@/api/AuthService";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder.vue";
import Multiselect from 'vue-multiselect';

export default {
  components: { Multiselect, LoadingPlaceholder, Breadcrumbs },
  data() {
    return {
      filters: {
        users: []
      },
      userColors: ["#32c9e5",
        "#F38630",
        "#FE4365",
        "#76caa5",
        "#6cb246",
        "#950eef",
        "#839037",
        "#0e55ef",
        "#5d2215",
        "#49fb7c",
        "#ffdc00",
        "#8a56f4",
        "#ff0800",
        "#184c06",
        "#aca062"],
      schedulingBirthday: false,
      isLoading: false,
      selectedYear: moment().locale('pt').format('YYYY'),
      data: [],
      holidays: [],
      localHolidays: [],
      hasMadeChanges: false,
      weekDays: [
        {
          id: 0,
          text: 'Seg'
        },
        {
          id: 1,
          text: 'Ter'
        },
        {
          id: 2,
          text: 'Qua'
        },
        {
          id: 3,
          text: 'Qui'
        },
        {
          id: 4,
          text: 'Sex'
        },
        {
          id: 5,
          text: 'Sab'
        },
        {
          id: 6,
          text: 'Dom'
        }
      ],
      months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
    };
  },
  async mounted() {
    await this.getVacationsData()
    //console.log(this.calendarData)
  },
  methods: {
    getVacationsData: async function() {
      //Gather data
      this.isLoading = true;
      const data = await AttendandeAndVacationsService.getVacations(moment(this.selectedYear, 'YYYY').startOf('year').format('YYYY-MM-DD'), moment(this.selectedYear, 'YYYY').endOf('year').format('YYYY-MM-DD'))
      data.forEach(elem => {
        elem.vacations.forEach(elem => {
          elem.momentDate = moment(elem.date, 'YYYY-MM-DD').locale('pt')
        })
      })
      this.data = data
      const holidays = await AttendandeAndVacationsService.getHolidays(2024)
      //this.holidaysForDisplayedDate = this.data[0].map(elem => elem.vacations.vacation)
      this.holidays = holidays.filter(elem => elem.type === 'national').map(elem => {
        return { date: this.moment(elem.date).locale('pt'), name: elem.title }
      })
      this.localHolidays = holidays.filter(elem => elem.type === 'local').map(elem => {
        return { date: this.moment(elem.date).locale('pt'), name: elem.title }
      })
      this.hasMadeChanges = false
      this.isLoading = false
    },
    handleDayClick: function (elem) {
      if(elem.day.type && (elem.day.type === 'holiday' || elem.day.type === 'weekend')) {
        return
      }

      const selfUserId = this.$auth.user().id
      const selfUserName= this.$auth.user().name
      const selfUserColor = this.userColors[this.data.findIndex(elem => elem.id === selfUserId)]

      const userData = this.data.find(elem => elem.id === selfUserId)
      if (userData.total_unscheduled === 0 && !elem.day.vacations.some(vac => vac.userId === selfUserId)) {
        return
      }
      const momentDate = moment(`${this.selectedYear}-${this.months.findIndex(month => month === elem.month)+1}-${elem.day.day}`, 'YYYY-MM-DD')
      //if user has no vacations we schedule until it is possible
      const foundUserVacation = elem.day.vacations.find(elem => elem.userId === selfUserId)
      if(!foundUserVacation) {
        const vacationData = {
          color: selfUserColor,
          type: "vacation",
          approved: false,
          userId: selfUserId,
          userName: selfUserName,
          unsubmitted: true,
        }
        //elem.day.vacations.push(vacationData)
        userData.vacations.push({
          date: momentDate.format('YYYY-MM-DD'),
          type: "vacation",
          approved_at: null,
          approved_by: null,
          created_by: null,
          updated_by: null,
          user_id: selfUserId,
          approval_status: "pending",
          unsubmitted: true,
          momentDate: momentDate
        })
        userData.total_unscheduled -= 1

        this.hasMadeChanges = true
        this.$forceUpdate()
        return
      }
      //else, we have a vacation on the click, so we "delete it"
      //elem.day.vacations.splice(elem.day.vacations.findIndex(elem => elem.userId === selfUserId), 1)
      const foundIndex = userData.vacations.findIndex(elem => elem.momentDate.isSame(momentDate, 'day'))
      if(foundIndex) {
        userData.vacations.splice(foundIndex, 1)
        userData.total_unscheduled += 1
        this.hasMadeChanges = true
        this.$forceUpdate()
      }
      /*if((data.vacation && data.vacation.type === 'holiday') || (data.date.day()%6===0)) {
        return
      }

      if(this.$auth.user().id !== data.resource.id && !this.hasApprovalPermission) {
        return
      } else {
        if(this.$auth.user().id !== data.resource.id && data.vacation) {
          //Handle approval
          if(data.vacation.approval_status === 'pending' || data.vacation.approval_status === 'unapproved') {
            //its already unapproved, so approve
            data.vacation.approved_at = moment()
            data.vacation.approval_status = 'approved_unsubmited'
            data.vacation.unsubmited = true
          } else if (data.vacation.approval_status === 'approved_unsubmited') {
            data.vacation.unsubmited = true
            data.vacation.approved_at = null
            data.vacation.approval_status = 'unapproved'
          }
          this.hasMadeChanges = true
          return
        }
      }

      if(data.resource.id === this.$auth.user().id) {
        const dateSelected = data.date
        //Data for the logged user is always the first elem
        const vacationIdx = this.data[0].vacations.findIndex(elem => elem.momentDate.isSame(dateSelected, 'day'))
        if(vacationIdx !== null) {
          if(this.data[0].vacations[vacationIdx].vacation === null) {
            if (this.data[0].total_unscheduled === 0){
              return
            }
            this.data[0].vacations[vacationIdx].vacation = {
              type: 'vacation',
              date: dateSelected.format('YYYY-MM-DD'),
              approved_at: null,
              unsubmited: true,
              approval_status: 'pending',
              user_id: this.$auth.user().id
            }
            this.data[0].total_unscheduled -= 1
            this.hasMadeChanges = true
          } else {
            this.data[0].vacations[vacationIdx].vacation = null
            this.data[0].total_unscheduled += 1
            this.hasMadeChanges = true
          }
        }
      }*/

    },
    handleChangeDate: function (type) {
      switch (type) {
        case 'previous':
          // change to previous date
          --this.selectedYear
          //this.submitVacationData()
          this.getVacationsData()
          break;
        case 'next':
          ++this.selectedYear
          //this.submitVacationData()
          this.getVacationsData()
          break;
        default: return

      }
    },
    capitalizeFirst: function (str) {
      return str[0].toUpperCase() + str.slice(1)
    },
    submitVacationData: async function() {
      const selfVacationsData = { vacations: this.data[0].vacations.filter(elem => elem.vacation !== null && elem.vacation.unsubmited === true).map(elem => elem.vacation) }
      try {
        await AttendandeAndVacationsService.patchVacations(selfVacationsData)
      } catch (e) {
        console.log(e)
      }

      //Submit approvals/unapprovals
      let approvals = this.data.filter(resource => resource.id !== this.$auth.user().id).map(elem => { return {"user_id": elem.id, "vacations": elem.vacations}})
      approvals = approvals.map(elem => {
        return {
          "user_id": elem.user_id,
          "approvals": elem.vacations.filter(elem => elem.vacation !== null && elem.vacation.type !== 'holiday' && elem.vacation.unsubmited === true).map(elem => elem.vacation)
        }
      })
      try {
        await AttendandeAndVacationsService.handleApprovals({approvals: approvals})
      } catch (e) {
        console.error(e)
      }
    },
    handleSubmitData: async function() {
      //First let's gatter the logged user data
      const userData = this.data.find(elem => elem.id === this.$auth.user().id)
      if (userData && userData.vacations.length > 0) {
        await AttendandeAndVacationsService.patchVacations({vacations: userData.vacations})
        await this.getVacationsData()
      }

    },
    daysInWeekOfMonth(year, month, weekNumber, dayOfWeek) {
      const days = [];
      const firstDayOfMonth = moment([year, month]);
      firstDayOfMonth.startOf('week');
      firstDayOfMonth.add(dayOfWeek, 'days');
      const startDate = firstDayOfMonth.clone().add(weekNumber, 'weeks');
      const endDate = startDate.clone().endOf('week');
      //console.log(this.data)
      const filteredUsersIds = this.filters.users.map(user => user.id)
      for (let i = 0; i < 7; i++) {
        const currentDate = startDate.clone().add(i, 'days');
        const matchingHoliday = this.holidays.find(elem => moment(elem.date).format('YYYY-MM-DD') === currentDate.format('YYYY-MM-DD'));
        const matchingLocalHoliday = this.localHolidays.find(elem => moment(elem.date).format('YYYY-MM-DD') === currentDate.format('YYYY-MM-DD'));

        let vacations = []
        this.data.forEach((user, index) => {
          if(this.filters.users.length > 0 && !filteredUsersIds.includes(user.id)) {
            return
          }
          const matchedVacs = user.vacations.filter(vac => vac.momentDate.isSame(currentDate))
          if (matchedVacs.length > 0) {
            vacations.push(...matchedVacs.map(elem => {
              return {
                userId: user.id,
                userName: user.name,
                color: this.userColors[index],
                type: elem.type,
                approved: elem.approved_at !== null
              }
            }))
          }
        })


        if (currentDate.month() === month) {
          if(currentDate.isoWeekday() === 7 || currentDate.isoWeekday() === 6) {
            days.push( {
              day: currentDate.date(),
              type: 'weekend'
            });
          } else if (matchingHoliday){
            days.push( {
              day: currentDate.date(),
              type: 'holiday',
              data: matchingHoliday
            });
          }else {
            const data = {
              day: currentDate.date(),
              type: 'normal',
              vacations: vacations,
              localHoliday: null
            }
          if (matchingLocalHoliday){
              data.localHoliday = {
                day: currentDate.date(),
                type: 'localHoliday',
                data: matchingLocalHoliday
              }
            }
            days.push(data);
          }

        } else {
          days.push(null);
        }
      }

      return days;
    }
  },
  computed: {
    usersOptions: function() {
      if(!this.data.length || this.data.length === 0) {
        return []
      }
      return this.data.map(elem => {
        return {
          id: elem.id,
          name: elem.name
        }
      })
    },
    daysDate: function() {
      let dates = []
      let idx = 1
      const startDate = this.displayedDate.clone().startOf('month')
      const endDate = this.displayedDate.clone().endOf('month')
      while (startDate.isSameOrBefore(endDate)) {
        dates.push({id: idx, momentDate: startDate.clone()});
        startDate.add(1, 'day');
        idx = idx+1
      }
      return dates
    },
    configService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollauth_server)
    },
    hasApprovalPermission: function () {
      return this.configService.user_permissions.some(perm => perm.access_type >= 2 && perm.info_type === 320)
    },
    calendarData: function () {
      let calendar = []

      this.months.forEach((month, index) => {
        let nrWeeks = 0
        const firstDayOfMonth = moment([this.selectedYear, index]);
        const lastDayOfMonth = moment(firstDayOfMonth).endOf('month');
        if(index === 11 && lastDayOfMonth.week() === 1) {
          //it's december and the last week might fall on the first one of the following month.
          let clonedLastDayOfMonth = lastDayOfMonth.clone()
          do {
            clonedLastDayOfMonth.add(-1, 'day')
          } while (clonedLastDayOfMonth.week() === 1)
          nrWeeks = clonedLastDayOfMonth.week() + 1 - firstDayOfMonth.week() + 1;
        } else {
          nrWeeks = lastDayOfMonth.week() - firstDayOfMonth.week() + 1;
        }


        let daysWithinWeeks = []

        for (let i = 0; i < nrWeeks; i++) {
          daysWithinWeeks.push(this.daysInWeekOfMonth(this.selectedYear, index, i, 1))
        }


        calendar.push({
          month: month,
          monthIdx: index+1,
          nrOfWeeks: nrWeeks,
          daysWithinWeeks: daysWithinWeeks
        })
      })

      return calendar
    }
  }
};
</script>

<style lang="scss" scoped>
.timeline-wrapper {
  overflow-x: auto;
}
.timeline {
  display: grid;
  grid-template-columns: 120px repeat(auto-fill,minmax(40px,1fr));
  grid-auto-flow: column;
  grid-auto-columns: minmax(40px,1fr);
  font-size: 14px;
}

.day-column {
  /* Style for day column */
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 2px;
  max-width: 40px;
  min-width: 40px;
  min-height: 40px;
  text-align: center;
}

.colaborator-column {
  /* Style for day column */
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 2px;
  max-width: 120px;
  min-width: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.is-weekend {
  background-color: #b7b7b7;
  color: white;
}

.is-holiday {
  background-color: #82edc0;
  color: white;
}

.is-local-holiday {
  background-color: rgba(135, 213, 185, 0.37);
  color: white;
}

.is-vacation-unapproval {
  background-color: #863131;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  padding: 17px;
}

.is-vacation-approved-unsubmited {
  background-color: #7b9657;
  border: 2px solid #863131;
  width: 25px;
  height: 25px;
  border-radius: 30px;
  padding: 15px;
}

.is-vacation-approved {
  background-color: #7b9657;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  padding: 17px;
}

.is-vacation-to-be-approved {
  width: 30px;
  height: 30px;
  border-radius: 30px;
  padding: 17px;
  background: repeating-linear-gradient(
    45deg,
    #7b9657,
    #7b9657 5px,
    #c2dea8 5px,
    #c2dea8 10px
  );
}

table {
  border: 1px solid #6E6E6E;
  border-collapse: separate;
  border-left: 0;
  border-radius: 4px;
  border-spacing: 0px;
}
thead {
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
  border-collapse: separate;
  background-color: #1ED78D;
}
.local-holiday-thead-bg {
  background-color: rgba(135, 213, 185, 0.37);
}
tr {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}
th, td {
  padding: 5px 4px 6px 4px;
  text-align: left;
  vertical-align: top;
  border-left: 1px solid #6E6E6E;
}
td {
  border-top: 1px solid #6E6E6E;
  //background-color: rgba(144, 220, 190, 0.66);
}
thead:first-child tr:first-child th:first-child, tbody:first-child tr:first-child td:first-child {
  border-radius: 4px 0 0 0;
}
thead:last-child tr:last-child th:first-child, tbody:last-child tr:last-child td:first-child {
  border-radius: 0 0 0 4px;
}

#days-left-table {
  thead {
    background-color: #dcdcdc !important;
  }
  td {
    background-color: #f6f6f6;
  }
}

.round {
  background-color: #949494 !important;
  color: #6e6e6e !important;
  border: none;
  border-radius: 50px;
  padding: 5px;
  font-size: 31px;
  height: 50px;
  width: 50px;
  box-shadow: 0 2px 4px darkslategray;
  cursor: pointer;
  transition: all 0.2s ease;
}

.round:hover {
  background-color: #505050 !important;
}

.round:active {
  box-shadow: 0 0 2px darkslategray;
  transform: translateY(2px);
}

.center-rounded {
  width: 120px;
  border-radius: 30px;
}

.year-calendar-wrapper {
  .table-month-header {
    background-color: #be915e;
    color: white;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }

  .table-weekdays-header {
    background-color: rgba(190, 145, 94, 0.2);

  }

  table {
    border-radius: 20px;
    border: 1px solid #cccccc;

  }

  tr {
    border: none
  }

  th {
    border: none
  }

  td {
    border: none;
    text-align: center;
    padding: 5px 0px 6px 0px;
  }

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.striped-background {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.75) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.75) 50%, rgba(255, 255, 255, 0.75) 75%, transparent 75%, transparent);
  background-size: 8px 8px;
}

</style>
